module.exports = __webpack_public_path__ + "img/pubg.88cd871f.jpeg";